/* ==========================================================================
   Solène interactions
   One rAF scroll loop, IntersectionObserver reveals, tabs, accordions.
   No dependencies. Respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Every section renders its own .vs wrapper, so the entrance class has to go
     on all of them — not just the first. (Tagging only the first left every
     other section's staged content stuck at opacity:0 — a blank hero.) */
  var roots = $$('.vs');
  if (!roots.length) return;
  var root = roots[0];

  /* ---------- entrance ---------- */
  requestAnimationFrame(function () {
    roots.forEach(function (el) { el.classList.add('vs-loaded'); });
  });

  /* ---------- scroll reveals ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vs-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
  $$('.vs-rv, .vs-mask, .vs-step').forEach(function (el) { io.observe(el); });

  /* ---------- header + scroll cue (one rAF loop) ---------- */
  var header = $('.vs-header');
  var cue = $('.vs-scrollcue');
  /* JS owns the cue's opacity outright: a CSS transition-delay for the intro
     would also delay the fade-out, leaving it hanging after you start scrolling. */
  var cueReady = false;
  if (cue) setTimeout(function () { cueReady = true; render(); }, 1250);
  var darkZones = $$('.vs-dark, .vs-footer');
  var ticking = false;

  function render() {
    var y = window.pageYOffset || document.documentElement.scrollTop;

    if (header) {
      header.classList.toggle('vs-stuck', y > 24);
      // the header pill sits over whatever section is behind it — invert it on dark
      var band = header.offsetHeight * 0.5 + 8;
      var onDark = darkZones.some(function (z) {
        var r = z.getBoundingClientRect();
        return r.top <= band && r.bottom >= band;
      });
      header.classList.toggle('vs-on-dark', onDark);
    }

    // the scroll prompt earns its place only before the first scroll
    if (cue && cueReady) {
      var fade = 1 - y / (window.innerHeight * 0.32);
      cue.style.opacity = Math.max(0, Math.min(1, fade)).toFixed(3);
    }
    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  render();

  /* ---------- tabs ---------- */
  var tabsNav = $('.vs-tabs__nav');
  if (tabsNav) {
    var tabs = $$('.vs-tab', tabsNav);
    var ind = $('.vs-tabs__ind', tabsNav);

    function moveIndicator(btn) {
      if (!ind || !btn) return;
      ind.style.width = btn.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
    }
    function select(btn) {
      tabs.forEach(function (t) {
        var on = t === btn;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('vs-active', on);
      });
      moveIndicator(btn);
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); n.focus(); select(n); }
      });
    });
    var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    if (initial) { requestAnimationFrame(function () { select(initial); }); }
    window.addEventListener('resize', function () {
      var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      moveIndicator(cur);
    }, { passive: true });
    // fonts can change tab widths after first paint
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
        moveIndicator(cur);
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  $$('.vs-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.vs-faq__item');
      var open = item.classList.toggle('vs-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- value-prop expanding rows ---------- */
  $$('.vs-vrow').forEach(function (row) {
    var toggle = function () {
      var open = row.classList.toggle('vs-open');
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    row.addEventListener('click', toggle);
    row.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  /* ---------- mobile menu ---------- */
  var burger = $('.vs-burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = root.classList.toggle('vs-menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('.vs-mobile-menu a').forEach(function (a) {
      a.addEventListener('click', function () {
        root.classList.remove('vs-menu-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('vs-menu-open')) burger.click();
    });
  }
})();
